// Tarih hücresi — bugün ise turuncu renkte gösterir.
// Kullanım: <DateCell value={r.due_date} />
import { fmtDate } from "@/utils/format";

const _todayIso = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export function isToday(value) {
  const iso = String(value || "").slice(0, 10);
  return iso && iso === _todayIso();
}

export function DateCell({ value, className = "" }) {
  const text = fmtDate(value);
  if (!value) return <span className={className}>—</span>;
  if (isToday(value)) {
    return (
      <span className={`text-orange-600 font-semibold ${className}`}
            title="Bugün" data-testid="today-highlight">
        {text}
      </span>
    );
  }
  return <span className={className}>{text}</span>;
}
